import { AccountMenu } from './account'
import { AdminMenu } from './admin'
import { ServicesMenu } from './services'
import { UserMenu } from './user'

export default class SubMenus {
  static Account = AccountMenu
  static Admin = AdminMenu
  static Services = ServicesMenu
  static User = UserMenu
}
